import React, { useState, useEffect} from 'react'
import { Button, IconButton, LinearProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import './ClassCard.css'
import { Link } from 'react-router-dom';

function ClassCard({style, name, id, teacherName, teacherPhoto, startDate, endDate, capacity, trainerName, trainerEmail}) {

  const getFormattedTime = (date) => {
   // const options = { hour: 'numeric', minute: 'numeric' };
   const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Intl.DateTimeFormat('en-IN', options).format(date);
  };

  const startDateTime = new Date(startDate);
  const endDateTime = new Date(endDate);
  //const remainingMinutes = Math.floor((endDateTime - Date.now()) / (1000 * 60));
  endDateTime.setMinutes(endDateTime.getMinutes() + 60);

  const getTimeRemaining = (totalMinutes) => {
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;
    return { days, hours, minutes };
  };

  const remainingMinutes = Math.floor((endDateTime - Date.now()) / (1000 * 60));
  //const vacancy = capacity - onlineStudents;
  const isClassEnded = remainingMinutes <= 0;

  const [timeRemaining, setTimeRemaining] = useState(getTimeRemaining(remainingMinutes));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemaining((prevTime) => {
        const newMinutes = prevTime.minutes - 1;
        return newMinutes >= 0
          ? { days: prevTime.days, hours: prevTime.hours, minutes: newMinutes }
          : getTimeRemaining(0);
      });
    }, 60000); // Update time remaining every minute

    return () => clearInterval(timer);
  }, []);


  return (
    <div className="classCard" style={style} >
      <div className="classCard__upper">
        <div className="classCard__className">{name}</div>
        
        <div className="classCard__classTime">
          <span>Start Date: {getFormattedTime(startDateTime)} </span>
          <span>End Date: {getFormattedTime(endDateTime)}</span>
        </div>

        {/*remainingMinutes > 0 ? (
          <>
          <p>{remainingMinutes} minutes left</p>
          <LinearProgress
          variant="determinate"
          value={(1 - remainingMinutes / (endDateTime - startDateTime)) * 100}
          className="classCard__progressBar"
        />
        </>
        ) : (
          <p>Class ended</p>
        )*/}

{!isClassEnded ? (
          <>
            <p>
              {timeRemaining.days > 0 && `${timeRemaining.days} days `}
              {timeRemaining.hours > 0 && `${timeRemaining.hours} hours `}
              {timeRemaining.minutes > 0 && `${timeRemaining.minutes} minutes` } left 
            </p>
           {/*} <LinearProgress
              variant="determinate"
              value={(1 - remainingMinutes / (endDateTime - startDateTime)) * 100}
              className="classCard__progressBar"
            /> */}
          </>
        ) : (
          <p>Class ended</p>
        )}

        <p>Logged in students: 5</p>


        <img src={teacherPhoto} className="classCard__creatorPhoto" />
      </div>
      <div className="classCard__middle">
        <p>Module Type: Module 1</p>
        <p>Room No: Module 1</p>
        <p>Capacity: {capacity}</p>
        <p>Remaining Seats: 5</p>
        <p>Delivery mode: online</p>
      </div>
      <div className="classCard__lower">
      {/*<Button variant="outlined" startIcon={<AddIcon />}>
          Enroll Now
        </Button>*/}
        <Link to='/class'>
      <Button variant="contained" endIcon={<SendIcon />}>
        Join Class
      </Button>
      </Link>
      </div>
    </div>
  )
}

export default ClassCard